import { render, staticRenderFns } from "./Get.vue?vue&type=template&id=401565cf&scoped=true&"
import script from "./Get.vue?vue&type=script&lang=js&"
export * from "./Get.vue?vue&type=script&lang=js&"
import style0 from "./Get.vue?vue&type=style&index=0&id=401565cf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401565cf",
  null
  
)

export default component.exports